import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { RegistrationService } from '../services/registration.service';

import { Customer } from '../models/Customer';

@Component({
  selector: 'app-register',
  templateUrl: './add-account-container.component.html',
  styleUrls: ['./add-account-container.component.css']
})
export class AddAccountContainerComponent implements OnInit {
  @ViewChild('registeremail') registerEmail: ElementRef;
  @ViewChild('registerbill') registerBill: ElementRef;
  @ViewChild('registerpersonalinfo') registerPersonalInfo: ElementRef;
  customer: Customer;
  //accountId: Number;
  emailNotFound = false;
  billNotFound = false;
  personalInfoNotFound = false;
  lookupByEmail = true;
  lookupByBill = false;
  lookupByPersonalInfo = false;
  captcha: any;


  showEmail = false;
  showBill = true;
  showPersonal = false;


  constructor(
    private service: RegistrationService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.customer = {
      username: '',
      password: '',
      email: '',
      accountNumber: '',
      accountId: '',
      customerUUID: '',
      webAccessCode: '',
      firstName: '',
      lastName: '',
      lastFourSSN: '',
      zipCode: 0,
      orgUnitId: '',
      userId: '',
      id: '',
      UserUUID: ''
    };
  }

  ngOnInit() {
  }

  onLookupClick() {
    return;
    //this.spinnerService.show();

    //let newCustomer: Customer = {
    //  accountNumber: this.customer.accountNumber,
    //  accountId: this.customer.accountId,
    //  customerUUID: this.customer.customerUUID,
    //  webAccessCode: this.customer.webAccessCode,
    //  username: this.customer.username,
    //  password: this.customer.password,
    //  email: this.customer.email,
    //  firstName: this.customer.firstName,
    //  lastName: this.customer.lastName,
    //  lastFourSSN: this.customer.lastFourSSN,
    //  zipCode: this.customer.zipCode,
    //  orgUnitId: this.customer.orgUnitId,
    //  userId: this.customer.userId,
    //  id: this.customer.id,
    //  UserUUID: this.customer.UserUUID
    //};

    //this.service.registerUser(newCustomer)
    //  .subscribe((res: any) => {
    //    if (res.success) {
    //      this.service.updateAccountId(res.accountID);
    //      this.router.navigate(['/About']);
    //      this.spinnerService.hide();
    //    } else {
    //      if (this.lookupByEmail) {
    //        this.emailNotFound = true;
    //      } else if (this.lookupByBill) {
    //        this.billNotFound = true;
    //      } else {
    //        this.personalInfoNotFound = true;
    //      }
    //      this.spinnerService.hide();
    //    }
    //  });
  }

  onCancel() {
    this.router.navigate(['/MyProfile/ManageAccounts']);
  }

  usingEmail() {
    this.showEmail = true;
    this.showBill = false;
    this.showPersonal = false;
    this.customer.email = "";
  }

  usingBillInfo() {
    this.showEmail = false;
    this.showBill = true;
    this.showPersonal = false;
    this.customer.accountNumber = "";
    this.customer.webAccessCode = "";
  }

  usingPersonalInfo() {
    this.showEmail = false;
    this.showBill = false;
    this.showPersonal = true;
    this.customer.firstName = "";
    this.customer.lastName = "";
    this.customer.lastFourSSN = "";
    this.customer.zipCode = 0;
  }

  resolvedCaptcha(captchaResponse: string) {
    console.log(`Resolved captcha for email with response ${captchaResponse}:`);
  }
}



// WEBPACK FOOTER //
// ./src/app/add-account-container/add-account-container.component.ts